// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ac-highlight{display:inline-block}.ac-highlight__field{font-style:italic;display:inline-block;margin:0 0.5rem}.ac-highlight__value{display:inline-block}.ac-highlight__part{display:inline-block}.ac-highlight__part--matched{font-weight:600;white-space:pre}\n", ""]);
// Exports
module.exports = exports;
